import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

function LookBackDaysModal({ onHide, onSubmit, title, label, placeholder, buttonText }) {
  const [lookBackDays, setLookBackDays] = useState('');

  const handleSubmit = () => {
    onSubmit(lookBackDays);
    onHide();
  };

  return (
    <Modal animation={false} show={true} onHide={onHide} centered>
      <Modal.Header className="py-2 mb-0" closeButton>
        <h5>{title}</h5>
      </Modal.Header>
      <Modal.Body className={css(styles.modalText)}>
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Form.Control
            value={lookBackDays}
            onChange={e => setLookBackDays(parseInt(e.target.value, 10))}
            placeholder={placeholder}
            type="number"
          />
        </Form.Group>
        <div className="w-100 text-right">
          <Button onClick={handleSubmit}>{buttonText}</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalText: {
    fontSize: '0.8rem',
  },
});

LookBackDaysModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  buttonText: PropTypes.string,
};

LookBackDaysModal.defaultProps = {
  title: 'Enter Look Back Days',
  label: 'Enter a value to look behind in days',
  placeholder: 'Example: 7',
  buttonText: 'Submit',
};

export default LookBackDaysModal;
